import { render, staticRenderFns } from "./TenantSetting.vue?vue&type=template&id=81155cf2&scoped=true"
import script from "./TenantSetting.vue?vue&type=script&lang=js"
export * from "./TenantSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81155cf2",
  null
  
)

export default component.exports